<template>
    <div>
      <Head :title="'Backtoworkconnect.ie'" />
      <v-container class="blogpost">
        <v-row align="center" justify="center" class="mt-5">
            <v-col cols="12" md="12" lg="8" >
        
            <v-card outlined elevation="24" rounded style="margin:auto">
            
                <v-card-title>
                    <span class="text-lg-h4 text-md-h4">{{ post.post_title }}</span>
                    
                </v-card-title>
                <v-card-subtitle class="border-bottom-purple">Back To Work Connect Career Hub: {{ categories }}</v-card-subtitle>
                <v-card-text v-if="image" class="text-center align-center justify-center">
                    <v-img style="margin:auto" :src="image" :width="500"></v-img>
                </v-card-text>
                <v-card-text v-html="formatText(post.post_content)">
                
                    
                </v-card-text>
                <v-card-text class="text-center p-5">
                    <v-btn outlined class="mr-3 mb-5" color="primary" v-for="t in tags" :key="'tagbtn_'+t">{{ t }}</v-btn>
                </v-card-text>
            </v-card>
        </v-col>
        </v-row>
      </v-container>
    </div>
</template>
<script>
  import { Head } from '@inertiajs/inertia-vue'
  import Layout from '@/Shared/VuetifyLayout'
  import axios from 'axios'

  export default {
    props: {
      auth: Object,
      state: String,
      baseurl: String,
      prevurl: String,
      post: Object,
      image: String,
      tags: Array,
      categories: String
    },
    components: {
      Head,
    },
    layout: Layout,
    data() {
        return {
        }
    },
    watch: {
    },
    created() {
    },
    methods: {
        formatText(t) {
            t = t.replace(/\/wp:\w+/g,'');
            t = t.replace(/wp:\w+/g,'');

            t = t.replace(/\{\"level\":\d\}/g,'');
            //let t = text.replaceAll('<!-- /wp:paragraph -->',"");
            t = t.replaceAll('<!--  -->','');
            /*t = t.replaceAll('<h2>','<span class="text-h2">');
            t = t.replaceAll('</h2>','</span>');
            t = t.replaceAll('<h3>','<span class="text-h3">');
            t = t.replaceAll('</h3>','</span>');
            t = t.replaceAll('<h4>','<span class="text-h4">');
            t = t.replaceAll('</h4>','</span>');
            t = t.replaceAll('<h5>','<span class="text-h5>"');
            t = t.replaceAll('</h5>','</span>');
            t = t.replaceAll('<!-- wp:paragraph -->',"");*/
            t = t.replaceAll("\n\n","\n");
            t = t.replaceAll("\n\n","\n");
            t = t.replaceAll("\n","<br/>");
            t = t.replace(/(\#\w+)/g, '<span class="primary--text">$1</span>'); 
            console.log(t);


            return t
        },
        toggleComponentLogin(e) {
            console.log('results triggering login',e)
            if (!this.auth.user)
                this.$parent.$emit('toggleComponentLogin',e);
        
        },
        
    },
  }
  </script>
  
  <style scoped>
    .fixedFooter {
    position: fixed;
    left: 0;
    bottom: 0;
    width: 100%;
    color: white;
    text-align: center;
    }

    

</style>